import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { Card, Button, message } from 'antd';
import { GoogleOutlined } from '@ant-design/icons';
import api from '../api';

const Login = () => {
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const response = await api.post('/auth/google', {
          access_token: tokenResponse.access_token
        });
        
        localStorage.setItem('token', response.data.access_token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        message.success(`환영합니다, ${response.data.user.name}님!`);
        navigate('/dashboard');
      } catch (error) {
        console.error('Login error:', error);
        message.error(error.response?.data?.detail || '로그인에 실패했습니다.');
      }
    },
    onError: () => {
      message.error('Google 로그인에 실패했습니다.');
    }
  });

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Card style={{ width: 400, textAlign: 'center' }}>
        <h1 style={{ color: '#1890ff', marginBottom: 8 }}>Marketing Hub</h1>
        <p style={{ color: '#666', marginBottom: 32 }}>관리자 전용 시스템입니다.</p>
        
        <Button 
          type="primary" 
          icon={<GoogleOutlined />}
          size="large"
          onClick={() => login()}
          style={{ width: '100%' }}
        >
          Google 계정으로 로그인
        </Button>
        
        <p style={{ marginTop: 24, fontSize: 12, color: '#999' }}>
          허용된 관리자만 접근할 수 있습니다.
        </p>
      </Card>
    </div>
  );
};

export default Login;
